import {
    ASSIGN_FIRMWARE_OPEN_MODAL,
    ASSIGN_FIRMWARE_CLOSE_MODAL,
    ASSIGN_FIRMWARE_GET_DEVICE_REQUEST,
    ASSIGN_FIRMWARE_GET_DEVICE_RESULT,
    ASSIGN_FIRMWARE_SET_DEVICE,
    ASSIGN_FIRMWARE_SEARCH_REQUEST,
    ASSIGN_FIRMWARE_SEARCH_RESULT,
    ASSIGN_FIRMWARE_REQUEST,
    ASSIGN_FIRMWARE_RESULT,
    ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT,
    ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT_RESULT,
    ASSIGN_BULK_FIRMWARE_REQUEST,
    ASSIGN_BULK_FIRMWARE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    device: null,
    selectedCameras: [],
    firmwares: [],
    loadingFirmwares: false,
    allCameras: [],
    loadingAllCameras: false,
    hardwareVersionCameras: [],
    groupingSelectedCameras: [],
    groupingByHarwareVersion: [],
    bulkUpdateFirmware: null,
    loadingBulkUpdateFirmware: false,
    backupAllCameras: []
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case ASSIGN_FIRMWARE_REQUEST:
            return { ...state, loading: true }

        case ASSIGN_FIRMWARE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case ASSIGN_FIRMWARE_OPEN_MODAL:
            return { ...state, openModal: true, selectedCameras: action.payload }

        case ASSIGN_FIRMWARE_CLOSE_MODAL:
            return { ...state, openModal: false }

        case ASSIGN_FIRMWARE_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case ASSIGN_FIRMWARE_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case ASSIGN_FIRMWARE_SET_DEVICE:
            return { ...state, selectedCameras: action.payload }

        case ASSIGN_FIRMWARE_SEARCH_REQUEST:
            return { ...state, loadingFirmwares: true }

        case ASSIGN_FIRMWARE_SEARCH_RESULT:
            return { ...state, firmwares: action.payload, loadingFirmwares: false }

        case ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT:
            return { ...state, loadingAllCameras: true }

        case ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT_RESULT:
            return {
                ...state,
                loadingAllCameras: false,
                allCameras: action.payload,
                backupAllCameras: action.payload,
            }

        case ASSIGN_BULK_FIRMWARE_REQUEST:
            return { ...state, loadingBulkUpdateFirmware: true }

        case ASSIGN_BULK_FIRMWARE_RESULT:
            return { ...state, loadingBulkUpdateFirmware: false, bulkUpdateFirmware: action.payload }

        case CLEAR_REDUX:
            return ["", "ASSIGN_FIRMWARE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};